import React from "react";
import { Link } from "react-router-dom";
import DataGrid from './data-grid';
import format from "../functions/format";
import moment from "moment";
export default class ActivityDateGrid extends React.Component {
  render() {
    var data = this.props.data;
    var columns = [{
      field: 'title',
      title: 'Name',
      cell: props => {
        var row = props.dataItem;
        var type = row.type;
        var name = row.title;
        var sanitizedName = name.replace(/ /g, '@');
        var startDate = moment(row.date).startOf('month').format('YYYY-MM-DD');
        var endDate = moment(row.date).endOf('month').format('YYYY-MM-DD');
        var detailLink = `/Activity/KeyValues/${type}/${sanitizedName}/${startDate}/${endDate}`;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, /*#__PURE__*/React.createElement(Link, {
          to: detailLink
        }, format(row.title, '-'))));
      }
    }, {
      field: 'total',
      title: 'Total',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(row.total, '-', 0, '')));
      }
    }, {
      field: 'users',
      title: 'Users',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(row.users, '-', 0, '')));
      }
    }, {
      field: 'sessions',
      title: 'Sessions',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(row.sessions, '-', 0, '')));
      }
    }, {
      field: 'value',
      title: 'Value',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, format(row.value, '-')));
      }
    }, {
      field: 'date',
      title: 'Date',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: format(row.date, '-')
        }, format(row.date, '-')));
      }
    }];
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}